import React, { useRef, useEffect } from "react";

export const FormSidebar = (props: {
  children: React.ReactNode;
  stickyTop?: string;
}) => {
  const { children, stickyTop } = props;
  const parentRef = useRef<HTMLDivElement | null>(null);
  const childRef = useRef<HTMLDivElement | null>(null);

  // Effect to handle initial height calculation
  useEffect(() => {
    if (parentRef.current && childRef.current) {
      const childHeight = childRef.current.clientHeight;
      const parentHeight = parentRef.current.clientHeight;

      if (childHeight > parentHeight) {
        parentRef.current.style.height = `${childHeight}px`;
      }

      // console.log("Child Height (Initial):", childHeight);
    }
  }, [stickyTop]);

  // Effect to handle updates triggered by changes in child content
  useEffect(() => {
    if (parentRef.current && childRef.current) {
      const childHeight = childRef.current.clientHeight;
      const parentHeight = parentRef.current.clientHeight;

      if (childHeight > parentHeight) {
        parentRef.current.style.height = `${childHeight}px`;
      }

      // console.log("Child Height (Update):", childHeight);
    }
  }, [children]);

  return (
    <div
      ref={parentRef}
      className="col-3 l-sidebar position-sticky sticky-top "
      style={{
        top: stickyTop ? stickyTop : "9rem",
        height: stickyTop ? `calc(100vh - ${stickyTop})` : "calc(100vh - 9rem)",
      }}
    >
      <div
        ref={childRef}
        className="d-flex flex-column p-4"
        style={{ minHeight: "100%" }}
      >
        {children}
      </div>
    </div>
  );
};

export const FormSidebarCallouts = (props: { children: React.ReactNode }) => {
  const { children } = props;
  return <div className="d-flex flex-column gap-3 mb-3">{children}</div>;
};

export const FormSidebarActions = (props: { children: React.ReactNode }) => {
  const { children } = props;
  return <div className="d-grid gap-3 mt-auto bg-white pt-4">{children}</div>;
};
